import { Injectable } from '@angular/core';
import { ObjectComment } from '../../dto/object-comment';
import { CrudService } from '../../services';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataListModel } from '../../models/data-list-model';
import { toServerDateString } from '../../providers/app-date-adapter';

@Injectable( {
  providedIn: 'root'
} )
export class ObjectCommentsService implements CrudService<ObjectComment> {
  readonly apiPath = 'object-comments/';

  constructor( private http: HttpClient ) { }

  add( item: ObjectComment ): Observable<Object> {
    return this.http.post( this.apiPath, item );
  }

  delete( id: number ) {
    const httpParams = new HttpParams().append( 'id', id.toString() );
      return this.http.delete( this.apiPath, { params: httpParams });
  }

  get( id: number) {
    return this.http.get( this.apiPath + id ) as Observable<ObjectComment>;
  }

   getForObject( id: number , target: number  ) {
    return this.http.get( this.apiPath + target + '/' + id ) as Observable<Array<ObjectComment>>;
  }

  restore( id: number) {
    return this.http.patch( this.apiPath + id , null);
  }

  getMany(): Observable<DataListModel<ObjectComment>> {
    throw new Error( 'Method not implemented.' );
  }

  update( item: ObjectComment ): Observable<Object> {
    throw new Error( 'Method not implemented.' );
  }

  deleteMany( ): Observable<Object> {
    throw new Error( 'Method not implemented.' );
  }

  restoreMany(): Observable<Object> {
    throw new Error( 'Method not implemented.' );
  }
}
